
import Base from '@/shared/app/ui/Base.vue';
import type CSS from 'csstype';
import { encode } from 'html-entities';
import Component from 'vue-class-component';

@Component
export default class TText extends Base {
  get content() {
    let baseContent =
      this.config.text?.toString() ||
      this.dataset(this.datasetName)[this.keyName]?.toString() ||
      '';

    baseContent = encode(baseContent);
    baseContent = baseContent.replace(/\*(\S.*\S)\*/g, '<strong>$1</strong>');
    baseContent = baseContent.replace(/,, /g, "<br/>");
    return baseContent;
  }

  get contentStyle(): CSS.Properties {
    const style: CSS.Properties = {
      fontSize: 'inherit',
      fontFamily: 'inherit',
      fontWeight: 'normal',
      color: 'inherit',
    };

    if (this.config.fontSize) style.fontSize = this.config.fontSize.toString();
    if (this.config.fontFamily)
      style.fontFamily = this.config.fontFamily.toString();
    if (this.config.fontWeight)
      style.fontWeight = this.config.fontWeight.toString();
    if (this.config.color) style.color = this.config.color.toString();
    if (this.config.padding) style.padding = this.config.padding.toString();
    if (this.config.backgroundColor)
      style.backgroundColor = this.config.backgroundColor.toString();
    if (this.config.borderRadius)
      style.borderRadius = this.config.borderRadius.toString();

    return style;
  }

  get datasetName() {
    return this.config.datasetName?.toString() || 'data';
  }

  get keyName() {
    return this.config.keyName?.toString() || 'text';
  }
}
